import { Pipe, PipeTransform } from '@angular/core';
import { E } from '@macs-frontend/core/utils/fp-ts';

@Pipe({ name: 'isLeft', pure: true })
export class IsLeftPipe implements PipeTransform {
  public transform<T>(value: E.Either<T, unknown>): value is E.Left<T> {
    return E.isLeft(value);
  }
}
